import { toast } from "sonner";

export async function copyText(text, label = "Copied") {
  if (!text) return false;
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
    } else {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    toast.success(label);
    return true;
  } catch (e) {
    toast.error("Copy failed — long-press or select the link to copy manually");
    return false;
  }
}
